
  // This file was autogenerated by dynamically running setEnv.ts and using dotenv for managing API key secrecy
  import { BrowserCacheLocation } from '@azure/msal-browser';
  const useLocalRedirectUri = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  export const environment = {
    production: false,
    version: '3.1.0-beta.704',
    updateAt: 'Sep 2, 2026 4:58 PM',
    baseURL: 'https://devapi.aisi.jnj.com/api/v1/',
    entryAPI: 'https://devapi.aisi.jnj.com/api/v1/',
    mapApiKey: 'AIzaSyAk9F3eFlvJEyqTyN3EFDr3Bnch7OkWFvM',
    pageSize: 10,
    gridPageSize: [5, 10, 20],
    environment: 'DEV',
    platformAdminADgroup: 'IOT-SIP-PLATFORMADMIN-DEV',
    STORAGE_DETAILS_ACCOUNTNAME:'tntstoragedev',
    STORAGE_DETAILS_SHARENAME:'tnt',
    STORAGE_DETAILS_SAS: 'sv=2021-06-08&ss=bfqt&srt=sco&sp=rwlacupx&se=2023-11-15T16:35:26Z&st=2022-11-15T08:35:26Z&spr=https&sig=1CFmfWCwNl%2FuPGPD9rNO%2BgdU5KZBhxgHHDz6aLZec6s%3D',
    STORAGE_DETAILS_ROOT_DIRECTORY_NAME: 'AuditorReconciliationReports',
    STORAGE_DETAILS_UPLOAD_SUB_DIRECTORY_NAME: 'uploads',
    STORAGE_DETAILS_REPORTS_SUB_DIRECTORY_NAME: 'reports',
    authConfig: {
      config: {
        auth: {
          tenant: 'jnj.onmicrosoft.com',
          clientId: '4f241a3b-96d8-400c-b9b1-c33c3d9a688c',
          authority: 'https://login.microsoftonline.com/jnj.onmicrosoft.com',
          redirectUri: useLocalRedirectUri ? window.location.origin : 'https://devui.aisi.jnj.com/',
          postLogoutRedirectUri: useLocalRedirectUri ? window.location.origin : 'https://devui.aisi.jnj.com/logout',
          navigateToLoginRequestUrl: false,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          loadFrameTimeout: 30000,
        },
      },
      angularConfig: {
        consentScopes: [
          'user.read',
          'https://graph.microsoft.com',
          'https://graph.windows.net',
        ],
        extraQueryParameters: {},
      },
    },
    lockInterval: 30, // In minutes
    appURLs: {
      GDCdev: 'https://gdcdev.appserviceenvna.na.ase.jnj.com/GDC/',
    },
    msalConfiguration: {
      auth: {
        tenant: 'jnj.onmicrosoft.com',
        clientId: '4f241a3b-96d8-400c-b9b1-c33c3d9a688c',
        authority: 'https://login.microsoftonline.com/jnj.onmicrosoft.com',
        knownAuthorities: [],
        redirectUri: useLocalRedirectUri ? window.location.origin : 'https://devui.aisi.jnj.com/',
        postLogoutRedirectUri: useLocalRedirectUri ? window.location.origin : 'https://devui.aisi.jnj.com/logout',
        navigateToLoginRequestUrl: false,
        cacheLocation: 'localStorage',
        loadFrameTimeout: 30000,
      },
    },
    msalLoginReq: {
      scopes: [ 'api://0760e066-b56d-46f4-8f4c-cfe38effca0b/user_impersonation'], // optional Array<string>
    },
    msalTokenReq: {
      scopes: [
         'api://0760e066-b56d-46f4-8f4c-cfe38effca0b/user_impersonation'
      ],
    }
  };
  